import _ from 'lodash'
import { Map, isImmutable } from 'immutable'
import { ftGetLocalStorage } from './common'

export const setActivePanel = (state, panel, { closeOthers = true } = {}) => {
  let retState = state

  if (closeOthers) {
    // Original behavior: set all panels to inactive
    retState = state.set(
      'panels',
      state.get('panels', Map()).map((v, k) => {
        if (isImmutable(v)) {
          return v.set('isActive', false)
        } else {
          return v
        }
      })
    )
  }

  if (retState.getIn(['panels', panel, 'open']) == true) {
    if (closeOthers) {
      // Original behavior: close other panels
      let listPanels = ['elementStyle', 'projectStyle', 'elemenSettings']
      _.each(listPanels, function (key) {
        retState = retState.setIn(['panels', key, 'isActive'], false)
      })
    }
    retState = retState.setIn(['panels', panel, 'isActive'], true)
  }

  if (closeOthers) {
    // Original panel state management behavior
    const panelStatus = ftGetLocalStorage('__ftPanelState')
    let panelState = {}
    if (panelStatus) {
      try {
        panelState = JSON.parse(panelStatus)
      } catch (err) {}
    }

    if (panel == 'elementStyle') {
      if (!retState.getIn(['panels', 'elemenSettings', 'pin'], false)) {
        retState = retState.setIn(['panels', 'elemenSettings', 'open'], panelState['elemenSettings'])
      }
    } else if (panel == 'elemenSettings') {
      if (!retState.getIn(['panels', 'elementStyle', 'pin'], false)) {
        retState = retState.setIn(['panels', 'elementStyle', 'open'], panelState['elementStyle'])
      }
    }
  }

  return retState
}
